/* Spanish catalog mirroring locale-transaction-detail-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'transaction.annulBy': 'Anulado por',
  "transaction.annulAudit": "Historial de anulación",
  "transaction.annulledAt": "Anulado el",
  "transaction.annulReason": "Motivo",
  "transaction.annulActor": "ID de usuario",
  "transaction.reversalDate": "Fecha contable del contraasiento",
  "transaction.openOriginal": "Abrir asiento original",
  "transaction.openReversal": "Abrir contraasiento",
  "transaction.auditMissing": "No registrado",
  "transaction.reversalMissing": "El contraasiento no está disponible en el diario cargado.",
  "transaction.auditDebit": "Debe",
  "transaction.auditCredit": "Haber",

  'transaction.incompleteBasis': 'La cobertura del diario es incompleta. Este justificante sigue disponible para documentación y diagnóstico; sus totales no deben tratarse como completos.',
  'route.transaction': 'Transacción',
  'transaction.back': 'Volver a todas las transacciones',
  'transaction.title': 'Transacción',
  'transaction.posting': 'Asiento',
  'transaction.summary': 'Resumen: importes que entran y salen de las cuentas',
  'transaction.account': 'Cuenta',
  'transaction.incoming': 'Entra en la cuenta',
  'transaction.outgoing': 'Sale de la cuenta',
  'transaction.total': 'Total',
  'transaction.description': 'Descripción',
  'transaction.links': 'Registros vinculados',
  'transaction.sourceLead': 'Este es el asiento de',
  'transaction.sourceHelp': 'Abre el origen para cambiar la transacción o un pago relacionado.',
  'transaction.relatedPayments': 'Pagos relacionados',
  'transaction.correctionReplacement': 'Justificante de sustitución',
  'transaction.correctionOriginal': 'Justificante original',
  'transaction.correctionReason': 'Motivo de la corrección',
  'transaction.created': 'Creado',
  'transaction.by': 'por',
  'transaction.vatCodes': 'Códigos de IVA',
  'transaction.accountNumber': 'N.º de cuenta',
  'transaction.name': 'Nombre',
  'transaction.amount': 'Importe',
  'transaction.documentation': 'Documentación',
  'transaction.generatedDocument': 'El documento de la factura se genera cuando lo abres o lo descargas.',
  'transaction.noDocumentation': 'No hay documentación adjunta a esta transacción.',
  'transaction.open': 'Asiento abierto',
  'transaction.locked': 'Asiento bloqueado',
  'transaction.annulled': 'Anulada',
  'transaction.fallbackType': 'Asiento',
  'transaction.notFound': 'Transacción no encontrada',
  'transaction.notFoundHelp': 'Puede que la transacción se haya anulado, pertenezca a otro ejercicio fiscal o ya no esté disponible.',
  'transaction.invoice': 'Factura',
  'transaction.purchase': 'Compra',
  'transaction.otherSale': 'Otra venta',
  'transaction.customs': 'Declaración de aduanas',
  'transaction.openDocument': 'Ver justificante',
  'transaction.download': 'Descargar',
  'transaction.upload': 'Subir adjunto',
  'transaction.uploaded': 'Adjunto subido.',
  'transaction.uploadFailed': 'No se pudo subir el adjunto.',
  'transaction.documentFailed': 'No se pudo obtener el justificante del backend.',
  'transaction.previewFailed': 'No se pudo mostrar el justificante.',
  'transaction.lost': 'Justificante perdido',
  'transaction.lostPrompt': 'Explicación para el registro (opcional):',
  'transaction.lostSaved': 'El justificante se ha marcado como perdido.',
  'transaction.lostFailed': 'No se pudo marcar el justificante como perdido.',
  'transaction.annul': 'Anular transacción',
  'transaction.annulQuestion': '¿Anular la transacción?',
  'transaction.creditQuestion': '¿Abonar la factura?',
  'transaction.credit': 'Abonar',
  'transaction.annulling': 'Anulando...',
  'transaction.annulHelp': 'La transacción se anula y se conserva en el historial, pero queda excluida de la base de los informes.',
  'transaction.creditHelp': 'La factura se abona con una nota de crédito creada como borrador para revisarla antes de enviarla.',
  'transaction.creditDraft': 'Se creó un borrador de nota de crédito. Revísalo y envíalo desde la lista de facturas.',
  'transaction.annulledSaved': 'La transacción se ha anulado.',
  'transaction.annulFailed': 'No se pudo anular la transacción.',
  'transaction.privateReimbursed': 'El gasto privado se ha reembolsado.',
  'transaction.privateReimburseFailed': 'No se pudo reembolsar el gasto privado.',
  'transaction.reimbursePrivate': 'Reembolsar gasto privado',
  'transaction.reimbursePrivateHelp': 'Contabiliza el reembolso desde la cuenta bancaria de la empresa seleccionada contra la cuenta 2060, sin volver a contabilizar el gasto ni el IVA.',
  'transaction.paymentDate': 'Fecha de pago',
  'transaction.bankAccount': 'Cuenta bancaria',
  'transaction.goTo': 'Ir a',
  'transaction.bank': 'Banco',
  'transaction.vat': 'IVA',
  'transaction.yearEnd': 'Cierre del ejercicio'
});
